"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.count = exports.progressBar = exports.star = exports.starWrapper = exports.itemWrapper = void 0;

var react_1 = require("@emotion/react");

exports.itemWrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 2px;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
exports.starWrapper = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  width: 44px;\n  margin-right: 8px;\n"])));
exports.star = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  margin-right: 1px;\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"])));
exports.progressBar = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n"])));
exports.count = react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  color: var(--gray-500);\n  word-break: keep-all;\n"])));